import netsContactAdd from './nets-contact-add';
import moduleConfig from './module-config';

export default angular
  .module('app.contact-add', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsContactAdd', netsContactAdd);
